import { api } from "../../../api";

export default async function destroy(encodedId: string) {
  try {
    const request = await api.delete("/user/preferences?removeId=" + encodedId);

    if (request) {
      localStorage.removeItem("userDetails");

      return request.data;
    }

    return null;
  } catch (msg) {
    return null;
  }
}
